/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleBigQueryResourceData
 */
export interface GoogleBigQueryResourceData {
    /**
     * 
     * @type {string}
     * @memberof GoogleBigQueryResourceData
     */
    projectId?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleBigQueryResourceData
     */
    datasetId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleBigQueryResourceData
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleBigQueryResourceData
     */
    location?: string | null;
}

/**
 * Check if a given object implements the GoogleBigQueryResourceData interface.
 */
export function instanceOfGoogleBigQueryResourceData(value: object): value is GoogleBigQueryResourceData {
    return true;
}

export function GoogleBigQueryResourceDataFromJSON(json: any): GoogleBigQueryResourceData {
    return GoogleBigQueryResourceDataFromJSONTyped(json, false);
}

export function GoogleBigQueryResourceDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleBigQueryResourceData {
    if (json == null) {
        return json;
    }
    return {
        
        'projectId': json['projectId'] == null ? undefined : json['projectId'],
        'datasetId': json['datasetId'] === undefined ? undefined : json['datasetId'] === null ? null : json['datasetId'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'location': json['location'] === undefined ? undefined : json['location'] === null ? null : json['location'],
    };
}

export function GoogleBigQueryResourceDataToJSON(json: any): GoogleBigQueryResourceData {
    return GoogleBigQueryResourceDataToJSONTyped(json, false);
}

export function GoogleBigQueryResourceDataToJSONTyped(value?: GoogleBigQueryResourceData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'projectId': value['projectId'],
        'datasetId': value['datasetId'],
        'displayName': value['displayName'],
        'location': value['location'],
    };
}

